import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { encrypttoHEX } from "../routes/encodedecode.js";

const baseURL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? ":" + window.location.port : ""}/`;
const reportBaseURL = "https://genz-staging.feeltiptop.com/";

const OrgCreate = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');
  const [sessionLink, setSessionLink] = useState("");
  const [reportLink, setReportLink] = useState("");
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const response = await axios.post(
        'https://genz-staging.feeltiptop.com/api/social_glass/organization',
        { name, description },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      const organizationId = response.data.organizationId;

      if (organizationId && response.data.success === true) {
        console.log("Org created successfully:", response.data);

        const orgJson = JSON.stringify({ orgID: organizationId });
        const encryptedOrgId = encrypttoHEX(orgJson);
        
        // Generate both session link and report link
        const session_link = baseURL + "socialglass?p=" + encryptedOrgId;
        const report_link = reportBaseURL + "socialglass/report?p=" + encryptedOrgId;
        
        setSessionLink(session_link);
        setReportLink(report_link);

        try {
          const sessionRes = await axios.post(
            "https://genz-staging.feeltiptop.com/api/social_glass/orgSessionLink",
            {
              org_id: organizationId,
              session_link: session_link,
              report_link: report_link,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          console.log("Session link and report link created successfully:", sessionRes.data);
        } catch (error) {
          console.error(
            "Error updating the session link and report link",
            error.response?.data?.error || error.message,
          );
        }
      }

      setMessage(response.data.message);
      setName('');
      setDescription('');

    } catch (error) {
      setMessage(error.response?.data?.error || 'Error creating organization');
    }
  };
  
  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="w-full max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="px-8 py-8 sm:p-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Create Organization</h2>
          
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="form-group">
              <label htmlFor="orgName" className="block text-base font-medium text-gray-700 mb-2">
                Organization Name
              </label>
              <input
                id="orgName"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="block w-full rounded-md border-gray-300 shadow-sm py-3 px-4 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base"
                placeholder="Enter organization name"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="description" className="block text-base font-medium text-gray-700 mb-2">
                Description
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={5}
                className="block w-full rounded-md border-gray-300 shadow-sm py-3 px-4 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base"
                placeholder="Enter organization description"
              />
            </div>
            
            <div className="pt-4">
              <button
                type="submit"
                className="w-full flex justify-center py-3 px-6 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 ease-in-out"
              >
                Create Organization
              </button>
            </div>
          </form>
          
          {message && (
            <div className={`mt-6 p-4 rounded-md text-base ${message.includes('Error') ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>
              {message}
            </div>
          )}
          
          {/* Display generated links after successful creation */}
          {sessionLink && reportLink && (
            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-md">
              <h3 className="text-lg font-medium text-blue-900 mb-3">Generated Links:</h3>
              <div className="space-y-2">
                <div>
                  <label className="block text-sm font-medium text-blue-700">Session Link:</label>
                  <p className="text-sm text-blue-600 break-all">{sessionLink}</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-blue-700">Report Link:</label>
                  <p className="text-sm text-blue-600 break-all">{reportLink}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrgCreate;